import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=aa99e806&scoped=true"
import script from "./TicketView.vue?vue&type=script&lang=js"
export * from "./TicketView.vue?vue&type=script&lang=js"
import style0 from "./TicketView.vue?vue&type=style&index=0&id=aa99e806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa99e806",
  null
  
)

export default component.exports